/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import { Grid, breakpoints } from '@coursera/cds-core';

import IsMobileScreenContext from 'bundles/page/contexts/IsMobileScreenContext';
import { HUB_PAGE_CONTENT_CONTAINER_MAX_WIDTH, NAVIGATION_OFFSET } from 'bundles/unified-seo-content-common/constants';

type Props = {
  heroBannerComponent: React.ReactNode;
  navigationComponent: React.ReactNode;
  contentComponent: React.ReactNode;
};

const styles = {
  heroBannerContainer: () => css`
    background-color: var(--cds-color-neutral-background-primary-weak);
  `,
  mainContainer: css`
    width: 100%;
    max-width: ${HUB_PAGE_CONTENT_CONTAINER_MAX_WIDTH}px;
    margin: 0 auto;
    ${breakpoints.up('md')} {
      margin-top: 24px;
    }
  `,
  contentContainer: css`
    margin: 0 auto;
    ${breakpoints.down('sm')} {
      width: 95%;
      max-width: 95%;
      margin-top: 24px;
    }
  `,
  navigationContainer: css`
    position: sticky;
    top: ${NAVIGATION_OFFSET};
    z-index: 10;
  `,
};

const Layout = ({ heroBannerComponent, navigationComponent, contentComponent }: Props) => {
  const { isMobileScreen } = useContext(IsMobileScreenContext);

  return (
    <Grid container direction="column" data-e2e="article-hub-page">
      <Grid item css={styles.heroBannerContainer} data-e2e="article-hub-page-header">
        {heroBannerComponent}
      </Grid>
      <Grid item container css={styles.mainContainer} spacing={isMobileScreen ? 0 : 48}>
        <Grid item xs={12} sm={12} md={3} css={styles.navigationContainer}>
          {navigationComponent}
        </Grid>
        <Grid item sm={12} md={9} css={styles.contentContainer}>
          {contentComponent}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Layout;
